import React from "react";
import founder from "../../assets/founder1.jpg";

const FounderSection = () => {
  return (
    <div className="section-bg my-5">
      <div className="container py-5">
        <div className="row">
            <h2 className="orange-text fs-5 fw-bold">Founder</h2>
          <div className="col-md-4 text-center d-flex flex-column justify-content-center align-items-center">
            <img
              className="rounded-circle mb-4"
              src={founder}
              alt="Founder"
              width="200"
              height="200"
            />
            <div className="fs-3 fw-bold text-dark">Manish Garg</div>
          </div>

          <div className="col-md-8">
            <h2 className="mb-3 blue-text fw-bolder text-center fs-1 mt-3 mb-4">Meet Our Founder</h2>
            <div className="fs-6 blue-text fw-normal">
            <p>
              Meet Manish, the founder of ooklass. <br/>
              As a student, Manish faced many difficulties in understanding complex problems, but he had a strong desire to excel
              in academics. He understood the common problems faced by students
              in their daily lives, especially when it came to understanding
              complex topics from books or from teachers in school who were in a
              rush to complete the syllabus.
            </p>
            <p>
              Manish's unique teaching method is a result of his own struggles
              and experiences as a student. He prepares his own notes and takes
              regular tests to ensure that his students understand the subject
              matter thoroughly. He puts in extra time and effort to clear any
              doubts that students may have, and he doesn't just focus on the
              task at hand, but on the ultimate goal that the student wants to
              achieve.
            </p>
            <p>
              With over 4 years of experience in teaching, Manish has helped
              many students achieve amazing scores in their exams. He believes
              that every student has the potential to excel, and with the right
              guidance and support, they can achieve their goals.
            </p>
            <p>
              Manish's dedication to his students is what sets him apart. He
              goes above and beyond to ensure that each and every student
              receives personalized attention and support. His passion for
              teaching and his commitment to his students is the driving force
              behind ooklass.
              <br />
              Join us today and let Manish help you achieve your academic goals.
            </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FounderSection;
